import { Buttons, FlexContainer, Text } from '@taxdown/piccolo-web';
import { locizeNS } from 'Services/i18n';
import { history } from 'Store';
import useTranslation from 'Hooks/useTranslation';
import { DifferenceIcon } from 'Components/icons/DifferenceIcon';
import { routes } from 'Constants/routes';
import * as Styled from '../../styles';
import * as StyledTwo from './styles';

const NewResultInfo = (): JSX.Element => {
  const { t } = useTranslation(locizeNS.PY);

  return (
    <Styled.ThreeColLayout>
      <Styled.TitleContainer type="fds_heading_bold_H4" color="dark_500">
        {t('PreviousYears.title')}
      </Styled.TitleContainer>
      <FlexContainer direction="column">
        <Styled.Title type="fds_heading_bold_H4" color="dark_500">
          {t('PreviousYears.title')}
        </Styled.Title>
        <Styled.ContainerInProgress>
          <StyledTwo.LoaderContainer
            direction="column"
            align="center"
            justify="center"
            gap="dimension_24"
          >
            <FlexContainer direction="column" align="center" justify="center" gap="dimension_08">
              <DifferenceIcon />
              <Text type="headline" color="dark" size="XS_M_S" align="center">
                {t('PreviousYears.newInfo.title')}
              </Text>
              <Text type="paragraphs" color="grey" size="S_L_S" align="center">
                {t('PreviousYears.newInfo.subtitle')}
              </Text>
            </FlexContainer>
            <Buttons.Classic
              size="m"
              label={t('PreviousYears.newInfo.button')}
              mode="primary"
              onClick={() => history.push(routes.PREVIOUS_YEARS)}
            />
          </StyledTwo.LoaderContainer>
        </Styled.ContainerInProgress>
      </FlexContainer>
    </Styled.ThreeColLayout>
  );
};

export default NewResultInfo;
